import store, { USER_STATUS } from '@/store/store'

/**
 * This returns the team details of passed teamId.
 * If user is not yet logged in, it subscribes to store and waits until store has teams set.
 * @param teamId
 * @returns {Promise<unknown>}
 */
const getTeamInfo = teamId => {
  return new Promise((resolve, reject) => {
    if (store.getters.status === USER_STATUS.NOT_LOGGED_IN) {
      reject()
    } else if (store.getters.status === USER_STATUS.LOGGED_IN) {
      const teamInfo = store.getters.teamById(teamId)
      if (teamInfo) {
        resolve(teamInfo)
      } else {
        reject()
      }
    } else {
      const unsubscribe = store.subscribe(mutation => {
        if (mutation.type === 'SET_TEAMS') {
          const teamInfo = store.getters.teamById(teamId)
          unsubscribe()
          if (teamInfo) {
            resolve(teamInfo)
          } else {
            reject()
          }
        } else if (mutation.type === 'SET_NOT_LOGGED_IN') {
          reject()
        }
      })
    }
  })
}

export default getTeamInfo
